export const personalDetailsFormDescription = {
  title: 'Personal Details',
  subTitle: 'Please start filling out your application by filling in your personal information below.',
};
